import { useState, createRef, useEffect } from "react";
import FeedbackAlert from "./FeedbackAlert";
import SettingsDashboard from "./SettingsDashboard";
import SidebarNavigation from "./SidebarNavigation";

const Settings = () => {
  const [navigationWidth, setNavigationWidth] = useState(undefined);
  const navigation = createRef();

  useEffect(() => {
    setNavigationWidth(() => {
      return navigation?.current?.offsetWidth;
    });
  }, [navigation, navigationWidth]);

  return (
    <>
      <FeedbackAlert />
      <div className="w-full flex">
        {/**Sidebar navigation*/}
        <SidebarNavigation navigation={navigation} />

        {/**Setting dashboard*/}
        <SettingsDashboard containerMaxWidth={navigationWidth} />
      </div>
    </>
  );
};

export default Settings;
